import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import * as fromCore from './../store/actions';
import * as fromCoreQuery from './../store/selectors';
import * as fromCoreState from './../store/reducers';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  constructor(public store: Store<fromCoreState.CoreState>) {}

  readonly httpState$ = this.store.select(fromCoreQuery.getHttpState);
  readonly http$ = this.store.select(fromCoreQuery.getHttp);
  readonly httpLoading$ = this.store.select(fromCoreQuery.getHttpLoading);
  readonly httpLoaded$ = this.store.select(fromCoreQuery.getHttpLoaded);

  setHttpHeader(payload?: string) {
    this.store.dispatch(fromCore.setHttpHeader({ payload }));
  }
}
